import React from "react";
import PropTypes from "prop-types";
import TooltipClassroomResourcesImage from "images/classroom_resources/TooltipClassroomResources.png";
import DarkPopover from "../shared/DarkPopover";

const PrintableResources = ({ downloadPaths }) => {
  const resources = [
    {
      amplitude: "downloadableDiscussionQuestionBundle",
      icon: "discussionq",
      label: "Discussion Questions",
      type: "discussion_questions"
    },
    {
      amplitude: "downloadableEssayPromptBundle",
      icon: "essay",
      label: "Essay Prompts",
      type: "essay_prompts"
    },
    {
      amplitude: "downloadableComprehensionCheckBundle",
      icon: "quiz",
      label: "Comprehension Checks",
      type: "comprehension_checks"
    },
    {
      amplitude: "downloadableQuickLitGuide",
      icon: "summary",
      label: "One-Page Quick Lit Guide",
      type: "quick_lit_guide"
    }
  ];

  return (
    <div className="tw-rounded-md tw-bg-white tw-shadow-[0px_1px_4px_0px_rgba(24,25,25,0.3)]">
      {/* Header */}
      <div
        className="tw-bg-light-teal-tint-95 tw-p-3 tw-flex tw-items-center
          tw-justify-between tw-rounded-t-md"
      >
        <div className="tw-flex tw-items-center tw-gap-2">
          <h3 className="banner-1 tw-m-0 tw-text-gray">Printable Resources</h3>
          <span className="tw-bg-bright-green tw-px-1.5 tw-rounded tw-text-xs tw-font-bold tw-leading-4 tw-text-gray">
            New
          </span>
        </div>
        <div className="dark-popover tw-flex tw-flex-1 tw-justify-end">
          <DarkPopover
            title="Get even more help"
            subcopy={[
              {
                alignment: "left",
                text: "Save prep time and study smarter with downloadable, classroom-ready materials."
              }
            ]}
            imageSrc={TooltipClassroomResourcesImage}
            imageAlt="Classroom Resources"
            visible={false}
            active
            forcePosition="below"
          />
        </div>
      </div>

      <div className="tw-overflow-hidden tw-rounded-b-md">
        {resources.map((resource) => (
          <a
            key={resource.type}
            href={downloadPaths[resource.type] || "#"}
            className="tw-group tw-flex tw-items-center tw-gap-2.5 tw-px-3 tw-py-2.5 tw-no-underline
        tw-transition-colors hover:tw-no-underline focus:tw-no-underline active:tw-no-underline"
            data-amplitude={resource.amplitude}
          >
            <span
              className={`lc-icon lc-icon-${resource.icon} tw-h-7 tw-w-7 lc-icon-md tw-shrink-0 tw-text-blue
          tw-no-underline hover:tw-no-underline focus:tw-no-underline active:tw-no-underline`}
            />
            <span className="banner-1 tw-text-gray group-hover:tw-underline group-focus:tw-underline">
              {resource.label}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

PrintableResources.propTypes = {
  downloadPaths: PropTypes.shape({
    comprehension_checks: PropTypes.string,
    discussion_questions: PropTypes.string,
    essay_prompts: PropTypes.string,
    quick_lit_guide: PropTypes.string
  }).isRequired
};

export default PrintableResources;
